/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1LocationStatesIdMutationRequest,
  PutApiV1LocationStatesIdMutationResponse,
  PutApiV1LocationStatesIdPathParams,
  PutApiV1LocationStatesId400,
  PutApiV1LocationStatesId401,
  PutApiV1LocationStatesId404,
  PutApiV1LocationStatesId409,
  PutApiV1LocationStatesId500,
} from "../../types/locationStateController/PutApiV1LocationStatesId.ts";

function getPutApiV1LocationStatesIdUrl(
  id: PutApiV1LocationStatesIdPathParams["id"],
) {
  const res = { method: "PUT", url: `/api/v1/location/states/${id}` as const };
  return res;
}

/**
 * @description Atualiza a sigla, o nome, a abreviação e o país de um estado. A sigla e o nome devem permanecer únicos. **(Requer Authorization para autenticação)**
 * @summary Atualizar estado (Requer Authorization para autenticação)
 * {@link /api/v1/location/states/:id}
 */
export async function putApiV1LocationStatesId(
  id: PutApiV1LocationStatesIdPathParams["id"],
  data?: PutApiV1LocationStatesIdMutationRequest,
  config: Partial<RequestConfig<PutApiV1LocationStatesIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1LocationStatesIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1LocationStatesId400
      | PutApiV1LocationStatesId401
      | PutApiV1LocationStatesId404
      | PutApiV1LocationStatesId409
      | PutApiV1LocationStatesId500
    >,
    PutApiV1LocationStatesIdMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1LocationStatesIdUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
